export default __webpack_public_path__ + "static/media/place_of_work.151634d0.jpg";